export type OptionState = "default" | "selected" | "correct" | "wrong";

type Params = {
  isAttempted?: boolean;
  isSelected?: boolean;
  isThisOptionCorrect: boolean;
};

export const getOptionState = ({
  isAttempted,
  isSelected,
  isThisOptionCorrect,
}: Params): OptionState => {
  if (isAttempted) {
    if (isThisOptionCorrect) return "correct";
    if (isSelected && !isThisOptionCorrect) return "wrong";
    return "default";
  }
  if (isSelected) return "selected";
  return "default";
};

export const cleanMathML = (html: string | null | undefined) =>
  (html ?? "").replace(/m:/g, "").replace(/<math[^>]*>/, "<math>");
